<template>
  <div class="exhibition">
    <div v-for="(item, index) in list" :key="index">
      <span class="text">{{item.text}}</span>
      <span class="number">{{item.number}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Exhibition',
  props: {
    list: Array
  },
}
</script>
<style lang="scss" scoped>
@import "../../../styles/mixins.scss";
.exhibition {
  display: flex;
  div {
    &:not(:last-child) {
      @include setBorder1px(right, rgba(255,255,255,.2));
    }
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    .text {
      font-family: PingFangSC-Regular;
      font-size: 24px;
      color: rgba(255,255,255,.6);
      margin-bottom: 5px;
    }
    .number {
      font-family: PingFangSC-Medium;
      font-size: 28px;
      color: #FFFFFF;
    }
  }
}
</style>
